// filepath: c:\Users\lucaa\source\repos\lagitfolio\src\components\body\PersonalSkillsChart.tsx
import React from 'react';
import {
  Chart as ChartJS,
  PointElement,
  Tooltip,
  Legend,
  RadarController,
  RadialLinearScale,
  LineElement,
  Filler,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './technicalLovingChart.scss';
ChartJS.register(
  Filler,

  PointElement,
  LineElement,
  Tooltip,
  RadialLinearScale,
  Legend,
  RadarController,
  ChartDataLabels
);
const TechnicalLovingChart: React.FC = () => {

  const data = {
    labels: [
      'Cybersecurity',
      'Data Analysis',
      'New Technologies',
      'Machine Learning',
      'Algorithms',
    ],
    datasets: [
      {
        label: '',
        data: [65, 59, 90, 81, 56],
        fill: true,
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgb(255, 99, 132)',
        pointBackgroundColor: 'rgb(255, 99, 132)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(255, 99, 132)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    layout: {
      padding: 0,
      autoPadding: false,
    },
    type: 'radar',
    data: data,
    options: {
      elements: {
        line: {
          borderWidth: 1,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: '#1c1c1cff',
        font: {
          weight: 'bold' as const,
          size: 9,
        },
        formatter: (value: any, context: any) => {
          return '';
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context: any) => {
            return ``;
          },
        },
        /*label: (context: any) => {
          const skill = context.dataset.label;
          const value = context.raw.r;
          return `${skill}: ${value}%`;
        },*/
      },
    },
    scales: {
      r: {
        display: true,
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20,
          showLabelBackdrop: false,
          color: '#1c1c1c11',
          font: {
            size: 6,
            weight: 'lighter' as const,
          },
        },
        grid: {
          color: '#e0e0e0',
          lineWidth: 1,
        },
      },
    },
  };

  return (
    <div className="technical-loving-chart">
      <Radar options={options} data={data} />
    </div>
  );
};

export default TechnicalLovingChart;
